import { ChangeDetectorRef, Directive, ElementRef, HostListener, Input, Renderer2, inject } from '@angular/core';

import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { BaseService } from '../base-service';
import { filter } from 'rxjs';
import { NavigationType } from '../definitions/base.definitions';
import { RouterManager } from '../managers/router.manager';


@Directive({
    selector: '[linkForRouter]',
    exportAs: 'linkForRouter'
})
export class RouterDirective extends BaseService {
    @Input('linkForRouter') link!: string;
    @Input() queryParams?: { [k: string]: any };
    @Input() fragment?: string;

    isActive = false;

    private readonly _RouterManager = inject(RouterManager);
    private readonly _Router = inject(Router);
    private readonly _Renderer = inject(Renderer2);
    private readonly _ElementRef = inject(ElementRef);

    ngOnInit(): void {
        this._ElementRef.nativeElement.href = this._RouterManager.CreateFullUrl(this.link, {
            queryParams: this.queryParams,
            fragment: this.fragment,
        });
        this.UpdateActiveState();
        this._Router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.UpdateActiveState();
        });
    }

    private UpdateActiveState(): void {
        if (!this.link) {
            this.isActive = false;
            this._Renderer.removeClass(this._ElementRef.nativeElement, 'active');
            return;
        }
        const segmentCount = this._Router.url.split('/').filter(s => s).length;
        const matchType = segmentCount === 1 ? 'exact' : 'subset';
        this.isActive = this._RouterManager.IsRouteActive(this.link, matchType as 'exact' | 'subset');
        if (this.isActive) {
            this._Renderer.addClass(this._ElementRef.nativeElement, 'active');
        } else {
            this._Renderer.removeClass(this._ElementRef.nativeElement, 'active');
        }
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): boolean {
        event.preventDefault();

        if (!this.link) {
            return false;
        }

        const extras: NavigationExtras = {
            queryParams: this.queryParams,
            fragment: this.fragment,
        };

        this.Navigate(this.link, extras, event.ctrlKey || event.metaKey ? NavigationType.NewTab : NavigationType.SameTab);

        return false;
    }
}
